import { SEOItemListElement, SEOWebPage } from '../../types'
import { makeId } from '../utils'

export interface SEOCollectionPageItem {
  docUrl: string
  title: string
  description?: string
}

export interface SEOGetCollectionPageInput {
  webpage: SEOWebPage
  itemList: SEOCollectionPageItem[]
}

export const getCollectionPage = ({ webpage, itemList }: SEOGetCollectionPageInput): SEOWebPage => {
  return {
    ...webpage,
    '@type': 'CollectionPage',
    '@id': makeId(webpage.url, 'webpage'),
    ...(itemList.length > 0 && {
      mainEntity: {
        '@type': 'ItemList',
        itemListElement: itemList.map(
          (item, index): SEOItemListElement => ({
            '@type': 'ListItem',
            position: index + 1,
            url: item.docUrl,
            name: item.title,
            ...(item.description ? { description: item.description } : {}),
          })
        ),
      },
    }),
  } as SEOWebPage
}
